module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Bancas")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Pesquisar",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-title', [_c('exam-filters', {
    attrs: {
      "options": ['semester', 'course'],
      "can-select-any-course": true,
      "semester-required": true
    },
    model: {
      value: (_vm.filters),
      callback: function($$v) {
        _vm.filters = $$v
      },
      expression: "filters"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "search": _vm.search,
      "pagination": _vm.pagination,
      "total-items": _vm.totalItems,
      "loading": _vm.loading,
      "no-data-text": _vm.noData,
      "no-results-text": _vm.noResult,
      "rows-per-page-text": _vm.rowsPerPageT
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [(!_vm.isSmallScreen && props.item.situation != 'Cancelada') ? _c('tr', {
          class: _vm.getExamRowClass(props.item)
        }, [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_c('ul', {
          staticClass: "no-padding"
        }, _vm._l((props.item.studentName), function(studentName, id) {
          return _c('ol', {
            key: id,
            staticClass: "no-padding studentName"
          }, [_vm._v("\n                            " + _vm._s(studentName) + "\n                        ")])
        }), 0)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(props.item.date, 'DD/MM/YYYY')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.hour))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.place))]), _vm._v(" "), _c('td', [(_vm.getExamStatus(props.item) == 'Finalizada') ? _c('v-chip', {
          class: ['grey darken-2', 'white--text'],
          attrs: {
            "small": ""
          }
        }, [_vm._v("\n                        Avaliação " + _vm._s(_vm.getExamStatus(props.item)) + "\n                    ")]) : (_vm.getExamStatus(props.item) == 'Pendente') ? _c('v-chip', {
          class: ['info', 'white--text'],
          attrs: {
            "small": ""
          }
        }, [_vm._v("\n                        Avaliação " + _vm._s(_vm.getExamStatus(props.item)) + "\n                    ")]) : _c('v-chip', {
          class: ['warning', 'white--text'],
          attrs: {
            "small": ""
          }
        }, [_vm._v("\n                        Avaliação " + _vm._s(_vm.getExamStatus(props.item)) + "\n                    ")])], 1), _vm._v(" "), _c('td', [(_vm.getExamStatus(props.item) != 'Finalizada') ? _c('v-btn', {
          attrs: {
            "color": "cyan darken-1",
            "floating": "",
            "small": "",
            "dark": "",
            "fab": "",
            "title": "Avaliar trabalho",
            "to": {
              name: 'examEvaluate',
              params: {
                id: props.item.id
              }
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("gavel")])], 1) : _vm._e(), _vm._v(" "), (_vm.getExamStatus(props.item) == 'Finalizada') ? _c('v-btn', {
          attrs: {
            "color": "info",
            "floating": "",
            "small": "",
            "dark": "",
            "fab": "",
            "title": "Ver ficha de avaliação",
            "to": {
              name: 'examDetail',
              params: {
                id: props.item.id
              }
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("description")])], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.isSmallScreen) ? _c('tr', {
          class: _vm.getExamRowClass(props.item)
        }, [_c('td', [_c('v-icon', [_vm._v("person")]), _vm._v(" "), _c('strong', [_c('ul', {
          staticClass: "no-padding"
        }, _vm._l((props.item.studentName), function(studentName, id) {
          return _c('ol', {
            key: id,
            staticClass: "no-padding studentName"
          }, [_vm._v("\n                                " + _vm._s(studentName) + "\n                            ")])
        }), 0)]), _c('br'), _vm._v(" "), _c('v-icon', [_vm._v("date_range")]), _vm._v(" " + _vm._s(_vm._f("moment")(props.item.date, 'DD/MM/YYYY')) + " às " + _vm._s(props.item.hour) + " "), _c('br'), _vm._v(" "), _c('v-icon', [_vm._v("edit_location")]), _vm._v(" " + _vm._s(props.item.place) + " "), _c('br'), _vm._v(" "), (_vm.getExamStatus(props.item) == 'Finalizada') ? _c('v-chip', {
          class: ['grey darken-2', 'white--text'],
          attrs: {
            "small": ""
          }
        }, [_vm._v("\n                        " + _vm._s(_vm.getExamStatus(props.item)) + "\n                    ")]) : (_vm.getExamStatus(props.item) == 'Pendente') ? _c('v-chip', {
          class: ['info', 'white--text'],
          attrs: {
            "small": ""
          }
        }, [_vm._v("\n                        " + _vm._s(_vm.getExamStatus(props.item)) + "\n                    ")]) : _c('v-chip', {
          class: ['warning', 'white--text'],
          attrs: {
            "small": ""
          }
        }, [_vm._v("\n                        " + _vm._s(_vm.getExamStatus(props.item)) + "\n                    ")])], 1), _vm._v(" "), _c('td', [(_vm.getExamStatus(props.item) != 'Finalizada') ? _c('v-btn', {
          attrs: {
            "color": "cyan darken-1",
            "floating": "",
            "small": "",
            "dark": "",
            "title": "Avaliar trabalho",
            "to": {
              name: 'examEvaluate',
              params: {
                id: props.item.id
              }
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("gavel")]), _vm._v(" Avaliar\n                    ")], 1) : _vm._e(), _vm._v(" "), (_vm.getExamStatus(props.item) == 'Finalizada') ? _c('v-btn', {
          attrs: {
            "color": "info",
            "floating": "",
            "small": "",
            "dark": "",
            "title": "Ver ficha de avaliação",
            "to": {
              name: 'examEvaluate',
              params: {
                id: props.item.id
              }
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("description")]), _vm._v(" Ver ficha\n                    ")], 1) : _vm._e()], 1)]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "pa-1 mb-0"
  }, [_vm._v("Acima estão listadas as bancas que você participa como examinador.")]), _vm._v(" "), _c('p', {
    staticClass: "green lighten-4 pa-1 mb-0"
  }, [_vm._v("Bancas realizadas hoje são exibidas com destaque "), _c('strong', {
    staticClass: "green--text"
  }, [_vm._v("verde")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "brown--text pa-1 mb-0"
  }, [_vm._v("Bancas em que você participa como examinador suplente são exibidas com destaque "), _c('strong', [_vm._v("marrom")]), _vm._v(".")])]), _vm._v(" "), _c('fullscreen-spinner')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24cbb4b7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExamEvaluateList.vue
// module id = 242
// module chunks = 0